import { $axios, apiList } from '@/api'

export default {
    actions: {
        getQuestionnaireById(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.questionnaire.getQuestionnaireById.method,
                    params: {
                        wsfunction: apiList.questionnaire.getQuestionnaireById.moodle_method,
                        id: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        submitQuestionnaireResponse(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.questionnaire.submitQuestionnaireResponse.method,
                    params: {
                        wsfunction: apiList.questionnaire.submitQuestionnaireResponse.moodle_method,
                        questionnaireid : payload.id,
                        surveyid: payload.surveyid,
                        userid: payload.userid,
                        cmid: payload.cmid,
                        sec: 1,
                        completed: 0,
                        rid: 0,
                        submit: 1,
                        action: 'submit',
                        ...payload.responses
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
    }
}
